module.exports = __webpack_public_path__ + "static/media/os-digger.d281ce19.png";